import { useState } from 'react';
import { Stack, Text } from '@fluentui/react';
import PricingParameterLoadError from './PricingParameterLoadError';
import PricingParameterScopeBar from './PricingParameterScopeBar';
import TenantPricingParameterPanel from './TenantPricingParameterPanel';
import {
  emptyParameterQuery,
  queryPricingItemId,
} from './pricingParameterHelpers';
import { usePricingParameterCatalog } from './usePricingParameterCatalog';

export interface TenantPricingParametersProps {
  tenantId: number;
  isAdmin: boolean;
}

const TenantPricingParameters = ({
  tenantId,
  isAdmin,
}: TenantPricingParametersProps) => {
  const catalog = usePricingParameterCatalog();
  const [query, setQuery] = useState(emptyParameterQuery);
  const pricingItemId = queryPricingItemId(query);

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      <PricingParameterScopeBar
        catalog={catalog}
        query={query}
        showDate
        onChange={setQuery}
      />
      <PricingParameterLoadError error={catalog.error} />
      {pricingItemId === undefined ? (
        <Text>
          Select a pricing item to see its effective parameters for this tenant.
        </Text>
      ) : (
        <TenantPricingParameterPanel
          key={`${pricingItemId}|${query.pricingDate}`}
          tenantId={tenantId}
          isAdmin={isAdmin}
          catalog={catalog}
          pricingItemId={pricingItemId}
          pricingDate={query.pricingDate}
        />
      )}
    </Stack>
  );
};

export default TenantPricingParameters;
